<template>
  <gd-login :callback="callback" class="bg-secondary-darker"></gd-login>
</template>

<script>
import Form from 'vform';
import axios from 'axios';
import GdLogin from '@groovepages/gd-ui-kit/components/Login';
import FunnelAffiliate from '@/models/FunnelAffiliate';
import store from '@/state';
import VueCookies from 'vue-cookies';

export default {
  layout: 'basic',
  data() {
    return {
      callback: (user) => {
        if (!user.auth_keycloak) {
          axios.defaults.headers.common = {
            ...axios.defaults.headers.common,
            'x-auth-provider': 'auth0',
          };
        }
        let self = this;
        store.commit('login', user);

        if (
          self.$route.query &&
          self.$route.query.redirect_funnel_id &&
          self.$route.query.redirect_funnel_id != ''
        ) {
          let funnelAffiliate = new FunnelAffiliate({});
          funnelAffiliate.funnel_id = self.$route.query.redirect_funnel_id;

          if (
            self.$route.query.gd_jv_cookie &&
            self.$route.query.gd_jv_cookie != ''
          ) {
            funnelAffiliate.gd_jv_cookie = self.$route.query.gd_jv_cookie;
          } else {
            funnelAffiliate.gd_jv_cookie = null;
          }

          if (
            self.$route.query.gs_jv_cookie &&
            self.$route.query.gs_jv_cookie != ''
          ) {
            funnelAffiliate.gs_jv_cookie = self.$route.query.gs_jv_cookie;
          } else {
            funnelAffiliate.gd_jv_cookie = null;
          }

          funnelAffiliate.save().then((response) => {
            self.$router.push({
              name: 'promos_dashboard',
              params: { id: self.$route.query.redirect_funnel_id },
            });
          });
        } else {
          self.$router.push({ name: 'dashboard' });
        }
      },
    };
  },
  components: {
    GdLogin,
  },
};
</script>
